export default __webpack_public_path__ + "static/sustainability-stamp-017a93b13cc6dd74a2534c3020a9ac5c.png";